window.addEventListener("load", (e) => {
  document.querySelectorAll(".block-tab_group").forEach((block) => {
    block.querySelectorAll(".tab-controls .tab-container").forEach((act) => {
      act.onclick = function (e) {
        // Activate button to change style
        act.dataset.active = "true";

        // Deactivate other buttons. Should not be more than 1. Using All and looping through them just in case.
        block
          .querySelectorAll(
            '.tab-controls .tab-container:not([data-activate="' +
              act.dataset.activate +
              '"])'
          )
          .forEach((btn) => {
            btn.dataset.active = "false";
          });

        // Activate tab to show
        block.querySelector(act.dataset.activate + "").dataset.active = "true";

        // Hide all other tabs. Should not be more than 1. Using All and looping through them just in case.
        block
          .querySelectorAll(
            '.block-tab_item[data-active="true"]:not(' +
              act.dataset.activate +
              ")"
          )
          .forEach((t) => {
            t.dataset.active = "false";
          });
      };
    });

    block.querySelectorAll(".tab-controls.mobile .tab-list button.tab-toggle-button-mobile").forEach((btn) => {
      btn.onclick = function (e) {

        if (btn.dataset.active === 'true') return;

        // Activate button
        btn.dataset.active = "true";

        // Deactivate other buttons. Should not be more than 1. Using All and looping through them just in case.
        block
            .querySelectorAll(
                '.tab-controls.mobile .tab-list button.tab-toggle-button-mobile:not([data-activate="' +
                btn.dataset.activate +
                '"])'
            )
            .forEach((b) => {
              b.dataset.active = "false";
            });

        // Activate tab to show
        block.querySelector(btn.dataset.activate + "").dataset.active = "true";

        // Hide all other tabs. Should not be more than 1. Using All and looping through them just in case.
        block
            .querySelectorAll(
                '.block-tab_item[data-active="true"]:not(' +
                btn.dataset.activate +
                ")"
            )
            .forEach((t) => {
              t.dataset.active = "false";
            });

        block.querySelector('.mobile-toggle span').innerText = btn.dataset.title;

      }
    })

  });
});
